import { Divider, Popover, Stack, ScrollArea } from "@mantine/core"
import { ReactNode } from "react"

import { Button } from "../../atoms/Button/Button"
import { SearchInput } from "../SearchInput/SearchInput"

export interface CriteriaBuilderPopoverProps {
  readonly buttonLabel: string
  readonly buttonIcon: ReactNode
  readonly isActive: boolean
  readonly searchPlaceholder: string | undefined
  readonly searchValue: string
  readonly onSearchChange: (value: string) => void
  readonly activeItems: ReactNode
  readonly availableItems: ReactNode
  readonly hasActiveItems: boolean
  readonly buttonSize?: "xs" | "sm" | "md" | "lg" | "xl"
  readonly searchInputSize?: "xs" | "sm" | "md" | "lg" | "xl"
  readonly searchInputWidth?: string | number
  readonly contentWidth?: string | number
}

export const CriteriaBuilderPopover = ({
  buttonLabel,
  buttonIcon,
  isActive,
  searchPlaceholder,
  searchValue,
  onSearchChange,
  activeItems,
  availableItems,
  hasActiveItems,
  buttonSize,
  searchInputSize,
  searchInputWidth,
  contentWidth,
}: CriteriaBuilderPopoverProps) => {
  return (
    <Popover position="bottom-start">
      <Popover.Target>
        <Button
          px="xs"
          variant={isActive ? "secondary" : "ghost"}
          rightSection={buttonIcon}
          fw={500}
          size={buttonSize}
        >
          {buttonLabel}
        </Button>
      </Popover.Target>
      <Popover.Dropdown>
        <ScrollArea.Autosize mah="50vh" mx="auto" scrollbars="y">
          <Stack gap="xs" w={contentWidth}>
            <SearchInput
              placeholder={searchPlaceholder}
              inputValue={searchValue}
              delay={0}
              onOpen={() => undefined}
              onChange={(value) => {
                onSearchChange(value?.toString() ?? "")
              }}
              size={searchInputSize}
              w={searchInputWidth}
            />
            {activeItems}
            {hasActiveItems ? <Divider /> : null}
            {availableItems}
          </Stack>
        </ScrollArea.Autosize>
      </Popover.Dropdown>
    </Popover>
  )
}
